import { GuestbookEvent } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'
import { ensureDefined } from '@/utils'
import { getEndpoint } from '@/ui/core/config'

export interface UpdateClosingInput {
  eventId: string
  closingHeader?: string
  closingMessage?: string
}

export async function updateClosing(
  this: GuestbookClient,
  input: UpdateClosingInput,
) {
  const jwtToken = await this.auth.getJWT()
  if (!jwtToken) {
    throw new Error('Missing token')
  }

  const { eventId, ...props } = input

  const event: Partial<GuestbookEvent> = {
    id: eventId,
    ...props,
  }
  await fetch(getEndpoint('events'), {
    method: 'PUT',
    body: JSON.stringify(event),
    headers: {
      Authorization: jwtToken,
    },
  })

  return ensureDefined(event.id)
}
